import { EventEmitterInterface } from 'pf-frontend-common/dist/module/event/emitter.interface';

import { DataStore } from 'common/module/data/store';
import { MyAccountListTypeEnum } from 'common/module/my-account/list-type.enum';
import { MyNotesNoteTemplatePropsInterface } from 'common/module/my-notes/note/template-props.interface';
import { MyNotesNoteViewStoreOptionsInterface } from 'common/module/my-notes/note/view-store-options.interface';

export class MyNotesNoteViewStore extends DataStore {
  /**
   * @inheritDoc
   */
  protected state: MyNotesNoteTemplatePropsInterface;

  /**
   * Constructor
   */
  public constructor(eventEmitter: EventEmitterInterface) {
    super(eventEmitter);
  }

  /**
   * @inheritDoc
   */
  public initialize(options: MyNotesNoteViewStoreOptionsInterface): void {
    this.state = {
      model: options.model,
      isExpanded: false,
      isReadMoreVisible: false,
      onTrim: this.onTrim,
      isShowDeleteButton: options.listType === MyAccountListTypeEnum.notes,
      onClickDelete: options.onClickDelete,
      onClickReadMore: this.onClickReadMore,
      onClickReadLess: this.onClickReadLess,
    };
  }

  /**
   * Clicked read more button
   */
  private onClickReadMore = () => {
    this.state.isExpanded = true;

    this.setState(this.state);
  };

  /**
   * Clicked read less button
   */
  private onClickReadLess = () => {
    this.state.isExpanded = false;

    this.setState(this.state);
  };

  /**
   * Trim note text
   */
  private onTrim = (isTrimNeeded: boolean) => {
    if (isTrimNeeded === this.state.isReadMoreVisible) {
      return;
    }

    this.state.isReadMoreVisible = isTrimNeeded;
    this.setState(this.state);
  };
}
